module.exports = __webpack_public_path__ + "img/4.107b584c.png";